var map = {
	"./access.png": "NTBv",
	"./add.png": "tfy+",
	"./ai-id.png": "+Rja",
	"./ai.png": "RYl6",
	"./analytic-dashboard.png": "GJbA",
	"./applications.png": "GEki",
	"./blank-blue.png": "C0SH",
	"./blank.png": "R6Vn",
	"./camera.png": "3OAi",
	"./canvas/barchart.png": "TUuS",
	"./canvas/linechart.png": "Fwc2",
	"./canvas/map.png": "GzPb",
	"./canvas/piechart.png": "u0iK",
	"./canvas/progress_bar.png": "NKy9",
	"./canvas/table.png": "gU32",
	"./canvas/text.png": "NdHi",
	"./check-blue.png": "oxtd",
	"./checked-green.png": "Yknn",
	"./code-blue.png": "iq2m",
	"./code.png": "mIXj",
	"./company.png": "0OZW",
	"./data-connectivity.png": "KJU7",
	"./data-manager.png": "ZL9A",
	"./error.png": "fafK",
	"./experience-manager.png": "RZFX",
	"./export-data.png": "x8Gr",
	"./features.png": "P3RW",
	"./fingerprint.png": "gXz4",
	"./form-2.png": "d5Vh",
	"./form.png": "ZMIQ",
	"./help.png": "5jV7",
	"./hyperlink.png": "8rqZ",
	"./info.png": "VHFR",
	"./layer.png": "JyTi",
	"./left.png": "8AFt",
	"./loader.png": "WfNd",
	"./location.png": "+tH1",
	"./model-default.png": "lgnA",
	"./native.png": "SVuy",
	"./no-file.png": "SCH1",
	"./payment-config.png": "URgt",
	"./payment-configuration.png": "4m2B",
	"./payment-monitoring.png": "IQo0",
	"./payment.png": "WH90",
	"./payroll.png": "I9Iw",
	"./plus.png": "lrNE",
	"./position.png": "/uRq",
	"./reload.png": "1pb4",
	"./scheduller-manager.png": "inI8",
	"./standalone.png": "CevL",
	"./storage.png": "Bq+1",
	"./template.png": "Mulj",
	"./third-party.png": "jmtn",
	"./times.png": "98IH",
	"./unit.png": "qoxJ",
	"./user.png": "TlOy",
	"./visual-programming.png": "AbkA",
	"./warning.png": "lk7M",
	"./widget-manager.png": "OzkA",
	"./workflow-manager.png": "fK6x"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YfKw";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon ^\.\/.*\.png$
// module id = YfKw
// module chunks = 46